var _ellipse, _path, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _rect, _path2, _path3, _line, _line2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBasic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 203,
    height: 139,
    viewBox: "0 0 203 139",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 175.857,
    cy: 79.7962,
    rx: 6.00487,
    ry: 6.00617,
    fill: "#949EB9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.0391 50.333C48.0391 48.1239 49.8299 46.333 52.0391 46.333H172.715C174.924 46.333 176.715 48.1239 176.715 50.333V54.9133H193.303C195.512 54.9133 197.303 56.7041 197.303 58.9133V68.0738C197.303 70.2829 195.512 72.0737 193.303 72.0737H164.132C159.476 76.0315 158.931 82.8826 162.496 87.5182H198.45C200.659 87.5182 202.45 89.3091 202.45 91.5182V100.679C202.45 102.888 200.659 104.679 198.45 104.679H157.269C151.996 109.162 151.996 117.356 157.269 121.839H186.44C188.649 121.839 190.44 123.63 190.44 125.839V135C190.44 137.209 188.649 139 186.44 139H7.4314C5.22226 139 3.4314 137.209 3.4314 135V125.839C3.4314 123.63 5.22226 121.839 7.4314 121.839H21.1617C26.4346 117.356 26.4346 109.162 21.1617 104.679H3.99999C1.79085 104.679 0 102.888 0 100.679V91.5182C0 89.3091 1.79086 87.5182 4 87.5182H140.685V72.0737H17.7253C15.5162 72.0737 13.7253 70.2829 13.7253 68.0737V58.9133C13.7253 56.7041 15.5162 54.9133 17.7253 54.9133H48.0391V50.333ZM133.823 104.679V121.839H44.6077V104.679H133.823Z",
    fill: "#F1F3F6"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 75.4898,
    cy: 12.0124,
    rx: 5.14703,
    ry: 5.14815,
    fill: "#949EB9"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.7404,
    cy: 36.8951,
    rx: 4.2892,
    ry: 4.29012,
    fill: "#E93A4D"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 126.96,
    cy: 13.7285,
    rx: 3.43136,
    ry: 3.4321,
    fill: "#949EB9"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 104.656,
    cy: 3.4321,
    rx: 3.43136,
    ry: 3.4321,
    fill: "#E93A4D"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 149.264,
    cy: 27.457,
    rx: 3.43136,
    ry: 3.4321,
    fill: "#E93A4D"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.5979,
    cy: 80.6543,
    rx: 3.43136,
    ry: 3.4321,
    fill: "#E93A4D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 60.333,
    y: 54.7534,
    width: 81.7839,
    height: 59.4938,
    rx: 6,
    fill: "white",
    stroke: "#2B2B45",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.083 92.2227L71.2007 61.3338L130.392 62.1918L102.083 92.2227Z",
    fill: "#00BFA5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.343 62.1916L101.225 93.9385L132.107 62.1916",
    stroke: "#2B2B45",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: -2,
    x2: 28.357,
    y2: -2,
    transform: "matrix(0.678201 -0.734877 0.73473 0.678359 68.627 107.667)",
    stroke: "#2B2B45",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 2,
    y1: -2,
    x2: 28.3567,
    y2: -2,
    transform: "matrix(0.70703 0.707183 -0.70703 0.707183 113.235 85.3584)",
    stroke: "#2B2B45",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasic);
export default __webpack_public_path__ + "static/media/Basic.f0a69512ed1e9b2ce1723c0da7c87bcf.svg";
export { ForwardRef as ReactComponent };